import { ClipboardCheck } from 'lucide-react';
import React from 'react';

import { FirmGuidelinesSidebar } from '@/components/intakes/FirmGuidelinesSidebar';
import { Button } from '@/components/ui/button';

interface IntakeLayoutProps {
  children: React.ReactNode;
  firmId?: string | null;
  intakeId?: string | null;
  matterId?: string | null;
  onSendEngagementLetter?: (options?: { cancelPrevious?: boolean }) => void;
  onOpenScreening?: () => void;
  hasScreeningData?: boolean;
}

const IntakeLayout: React.FC<IntakeLayoutProps> = ({
  children,
  firmId,
  intakeId,
  matterId,
  onSendEngagementLetter,
  onOpenScreening,
  hasScreeningData,
}) => {
  return (
    <div className="flex h-full w-full">
      <div className="flex-1 min-h-0 overflow-y-auto relative">
        {children}
        {/* Screening sheet button - fixed at bottom right */}
        {onOpenScreening && (
          <Button
            onClick={onOpenScreening}
            variant="outline"
            size="sm"
            className="fixed bottom-4 right-4 z-20 shadow-md bg-white hover:bg-zinc-50 border-zinc-300"
          >
            <ClipboardCheck className="h-4 w-4 mr-2" />
            {hasScreeningData ? 'View Screening' : 'Start Screening'}
          </Button>
        )}
      </div>
      {firmId && (
        <FirmGuidelinesSidebar
          firmId={firmId}
          intakeId={intakeId}
          matterId={matterId}
          onSendEngagementLetter={onSendEngagementLetter}
        />
      )}
    </div>
  );
};

export default IntakeLayout;
